module.exports = __webpack_public_path__ + "static/img/9.227ce3e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/1/sp/9.png
// module id = 3EHd
// module chunks = 0